import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import currency from "currency.js";
// import moment from "moment";

import { URLS } from "../urls";
import { Helmet } from "react-helmet";
import Topbar from "../topbar/Topbar";
import Sidebar from "../sidebar/Sidebar";
import ApplyLoanModal from "./ApplyLoanModal";
import LoanDetails from "./LoanDetails";
import LoanHistory from "./LoanHistory";
import { DownArrowIcon, SummaryChartIconUp, SummaryCloseIcon } from "../icons";
import RsDateRangePicker from "../RsDateRangePicker";
import { EditTermsModal } from "./EditTerms";
import {
  arrangeEventObject,
  fetchActionsUtil,
  stringifyQueryString,
  useCookie,
} from "../../utils";
import { UseQueryData } from "../UseQueryData";
import CustomPagination from "../Paginations";
import ModalLoader from "../ModalLoader";
const allMonths = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const Loan = () => {
  // ------------------ Filter Search -------------------//
  const initialQueryParams = {
    limit: 20,
    page: 1,
    status: "",
    startDate: "",
    endDate: "",
    id: "",
    name: "",
  };
  const { queryParams, theQueryParams, onChangeInput, setQueryParams } =
    UseQueryData({
      initialQueryParams,
      timer: 1500,
    });
  // ------------------ Filter Search -------------------//

  const [returnParams, setReturnParams] = useState({
    count: 0,
    endIndex: 0,
    startIndex: 0,
  });

  const branch_id = useCookie("branch_id");

  const [state, setState] = useState({
    appliedLeaves: [],
    openLoanDetails: false,
    requestid: "",
    openLoanHistory: false,
    staff: "",
    btnSummryActive: false,
    showTerm: false,
    selectedLoan: {},
  });

  const [isLoading, setIsLoading] = useState(false);
  const [showApply, setShowApply] = useState(false);

  const componentDidMount = async () => {
    try {
      setIsLoading(true);

      const token = "dummy token";

      const loanData = fetchActionsUtil(
        `${URLS.backendLoan}/by-branch/${branch_id}?${stringifyQueryString(
          queryParams
        )}`,
        "GET",
        token
      );

      const loanTotalData = fetchActionsUtil(
        `${URLS.backendLoan}/allTotals/${branch_id}`,
        "GET",
        token
      );

      const [loanResult, loanTotalResult] = await Promise.all([
        loanData,
        loanTotalData,
      ]);

      setState((el) => ({
        ...el,
        stats: loanTotalResult,
        appliedLeaves: loanResult.loan,
      }));

      setReturnParams({
        count: loanResult.count,
        endIndex: loanResult.endIndex,
        startIndex: loanResult.startIndex,
      });
    } catch (error) {
      console.log({ error });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      componentDidMount();
    }

    return () => {
      isMounted = false;
    };
  }, [branch_id, queryParams]);

  const showDateInFormat = (date) => {
    date = date.split("/");
    return (
      ("0" + date[0]).slice(-2) + " " + allMonths[date[1] - 1] + " " + date[2]
    );
  };

  const filterByDateRange = (event, picker) => {
    onChangeInput(
      arrangeEventObject({
        name: "startDate",
        value: picker.startDate,
      })
    );

    onChangeInput(
      arrangeEventObject({
        name: "endDate",
        value: picker.endDate,
      })
    );

    picker.element.val(
      picker.startDate.format("DD/MM/yyyy") +
        " - " +
        picker.endDate.format("DD/MM/yyyy")
    );
  };

  const clearDateRange = (event, picker) => {
    onChangeInput(
      arrangeEventObject({
        name: "startDate",
        value: "",
      })
    );

    onChangeInput(
      arrangeEventObject({
        name: "endDate",
        value: "",
      })
    );

    picker.element.val("");
  };

  const dropDownFunction = (qty) => {
    setQueryParams((el) => ({ ...el, limit: qty }));
  };

  const {
    stats,
    appliedLeaves,
    loggedEmployee,
    openLoanDetails,
    requestid,
    openLoanHistory,
    staff,
    btnSummryActive,
    showTerm,
    selectedLoan,
  } = state;
  return (
    <body>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex, nofollow"></meta>
        <title>InvexERP</title>
      </Helmet>
      <div className="main-wrapper">
        <Topbar />
        <Sidebar />
        {/*<!-- Page Wrapper -->*/}
        <div className="page-wrapper">
          {/*<!-- Page Content -->*/}
          <div className="content container-fluid">
            {/*<!-- Page Title -->*/}
            <div className="d-flex justify-content-between align-item-baseline mb-4 mt-2">
              <div className="d-flex align-item-baseline">
                <h4 className="page-title">Loan</h4>
              </div>

              <div className="d-flex align-item-baseline flex-wrap gap-3">
                <div className="">
                  <button
                    className="btn add-btn"
                    onClick={() => setShowApply(true)}
                  >
                    <i className="fa fa-plus"></i> Apply Loan
                  </button>
                </div>
                <div>
                  <button
                    onClick={() =>
                      setState((el) => ({
                        ...el,
                        btnSummryActive: !btnSummryActive,
                      }))
                    }
                    className="btn summaryBtn mx-3"
                  >
                    Show Summary
                  </button>
                </div>
              </div>
            </div>
            {/*<!-- /Page Title -->*/}

            {/*<!-- Leave Statistics -->*/}
            <section className="stats">
              <div
                className="stat p-cursor"
                onClick={() =>
                  onChangeInput(
                    arrangeEventObject({
                      name: "status",
                      value: "",
                    })
                  )
                }
              >
                <div className="icon icon-3">
                  <i class="fa fa-money"></i>
                </div>
                <div className="details">
                  <p>{appliedLeaves.length}</p>
                  <span className="dashboard-links">Total Loan </span>
                </div>
              </div>
              <div
                className="stat p-cursor"
                onClick={() =>
                  onChangeInput(
                    arrangeEventObject({
                      name: "status",
                      value: "Approved",
                    })
                  )
                }
              >
                <div className="icon icon-1">
                  <i class="fa fa-money"></i>
                </div>
                <div className="details">
                  <p>
                    {
                      appliedLeaves.filter((d) => d.status === "Approved")
                        .length
                    }
                  </p>
                  <span className="dashboard-links">Approved Loan </span>
                </div>
              </div>
              <div
                className="stat p-cursor"
                onClick={() =>
                  onChangeInput(
                    arrangeEventObject({
                      name: "status",
                      value: "Pending",
                    })
                  )
                }
              >
                <div className="icon icon-4">
                  <i class="fa fa-money"></i>
                </div>
                <div className="details">
                  <p>
                    {appliedLeaves.filter((d) => d.status === "Pending").length}
                  </p>
                  <span className="dashboard-links">Pending Loan </span>
                </div>
              </div>
              <div
                className="stat p-cursor"
                onClick={() =>
                  onChangeInput(
                    arrangeEventObject({
                      name: "status",
                      value: "Disapproved",
                    })
                  )
                }
              >
                <div className="icon icon-2">
                  <i class="fa fa-money"></i>
                </div>
                <div className="details">
                  <p>
                    {
                      appliedLeaves.filter((d) => d.status === "Disapproved")
                        .length
                    }
                  </p>
                  <span className="dashboard-links">Disapproved Loan </span>
                </div>
              </div>
            </section>
            {/*<!-- /Leave Statistics -->*/}

            {/* Searches */}

            <div className="grid-cat-1 filter-row">
              <>
                <div className="">
                  <div className="form-group form-focus">
                    <input
                      type="text"
                      placeholder="Employee Id"
                      className="form-control floating"
                      value={theQueryParams.id}
                      name="id"
                      onChange={(e) => onChangeInput(e)}
                    />
                  </div>
                </div>
                <div className="">
                  <div className="form-group form-focus">
                    <input
                      type="text"
                      placeholder="Employee name"
                      className="form-control floating"
                      value={theQueryParams.name}
                      name="name"
                      onChange={(e) => onChangeInput(e)}
                    />
                  </div>
                </div>
              </>

              <div className="">
                <div className="form-group form-focus text-gray-400 d-flex align-items-center justify-content-between">
                  <select
                    className="form-control floating"
                    value={theQueryParams.status}
                    name="status"
                    onChange={(e) => onChangeInput(e)}
                  >
                    <option value="">All</option>
                    <option value="Approved">Approved</option>
                    <option value="Pending">Pending</option>
                    <option value="Disapproved">Disapproved</option>
                  </select>
                  <div className=" pr-2">
                    <DownArrowIcon color="#6c757d" />
                  </div>
                </div>
              </div>

              <div className="search-date cal-icon">
                <RsDateRangePicker
                  placement="bottomEnd"
                  onClean={(event, picker) => clearDateRange(event, picker)}
                  onOk={(event, picker) => filterByDateRange(event, picker)}
                  placeholder="Select From and To Date"
                />
              </div>
            </div>

            {/* Searches */}
            <div className="row">
              <div className="col-md-12">
                <div className="">
                  <table className="table table-striped custom-table mb-0 datatable">
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Name</th>
                        <th>Title</th>
                        <th>Amount</th>
                        <th>Repayment</th>
                        <th>Balance</th>
                        <th>Deduct Amount</th>
                        <th>Status</th>
                        <th>Payment Status</th>
                        <th className="text-center">Term</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {appliedLeaves?.length
                        ? appliedLeaves?.map((loan, i) => {
                            return (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{`${
                                  loan?.user?.personalInfo?.name?.first || ""
                                } ${
                                  loan?.user?.personalInfo?.name?.middle || ""
                                } ${
                                  loan?.user?.personalInfo?.name?.last || ""
                                }`}</td>
                                <td>{loan?.Title}</td>
                                <td>
                                  {currency(loan?.Amount, {
                                    symbol: "",
                                  }).format()}
                                </td>
                                <td>
                                  {loan?.paid
                                    ? currency(loan?.paid, {
                                        symbol: "",
                                      }).format()
                                    : 0}
                                </td>
                                <td>
                                  {!loan?.paid
                                    ? currency(loan?.Amount, {
                                        symbol: "",
                                      }).format()
                                    : loan?.balance
                                    ? currency(loan?.balance, {
                                        symbol: "",
                                      }).format()
                                    : 0}
                                </td>
                                <td>
                                  {loan?.payments?.length > 0
                                    ? currency(loan?.payments[0], {
                                        symbol: "",
                                      }).format()
                                    : 0}
                                </td>
                                <td
                                  className={`fw-bold ${
                                    loan.status === "Approved"
                                      ? "text-success"
                                      : loan.status === "Disapproved"
                                      ? "text-danger"
                                      : "text-pending"
                                  }`}
                                >
                                  {loan.status}
                                </td>
                                <td
                                  className={`text-center fw-bold ${
                                    loan?.paymentsStatus === "Paid"
                                      ? "text-success"
                                      : "text-primary"
                                  }`}
                                >
                                  {loan.paymentsStatus}
                                </td>
                                <td>
                                  {loan?.paymentsStatus === "Paid" ? (
                                    <div className="dropdown action-label p-cursor">
                                      <div className="btn btn-white btn-sm btn-rounded dropdown-toggle px-2">
                                        <i className="fa fa-dot-circle-o text-success mx-2 text-center"></i>

                                        {loan?.motions &&
                                        loan?.loanmotion !== "Resume"
                                          ? loan?.loanmotion
                                          : loan?.Term
                                          ? loan?.Term
                                          : "Pending"}
                                      </div>
                                    </div>
                                  ) : (
                                    loan.status === "Pending" && "Pending"
                                  )}
                                </td>
                                <td>{showDateInFormat(loan?.applyDate)}</td>

                                <td>
                                  <div className="dropdown dropdown-action p-cursor">
                                    <div
                                      className="action-icon dropdown-toggle"
                                      data-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i className="material-icons">
                                        more_vert
                                      </i>
                                    </div>
                                    <div className="dropdown-menu dropdown-menu-right">
                                      <div
                                        className="dropdown-item"
                                        data-toggle="modal"
                                        data-target="#edit_leave"
                                        onClick={() =>
                                          setState((item) => ({
                                            ...item,
                                            openLoanDetails: true,
                                            requestid: loan?.requestid,
                                            staff: loan?.staff,
                                          }))
                                        }
                                      >
                                        <i className="fa fa-rss m-r-5"></i> View
                                        Approval Progress
                                      </div>
                                      <div
                                        className="dropdown-item"
                                        data-toggle="modal"
                                        data-target="#delete_leave"
                                        onClick={() =>
                                          setState((item) => ({
                                            ...item,
                                            openLoanHistory: true,
                                            requestid: loan?.requestid,
                                          }))
                                        }
                                      >
                                        <i className="fa fa-history m-r-5"></i>{" "}
                                        View Repayment History
                                      </div>

                                      {loan?.paymentsStatus === "Paid" &&
                                        loan?.status !== "Completed" && (
                                          <div
                                            className="dropdown-item"
                                            onClick={() =>
                                              setState((item) => ({
                                                ...item,
                                                showTerm: true,
                                                selectedLoan: loan,
                                              }))
                                            }
                                          >
                                            <i className="fa fa-edit m-r-5"></i>{" "}
                                            Edit Term
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        : ""}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div
              className={
                btnSummryActive
                  ? `summaryNew border-top open`
                  : `summaryNew border-top`
              }
            >
              <div className="row justify-content-between mt-4">
                <div className="col">
                  <div className="my-3">
                    <div className="d-flex gap-3 align-items-center mb-4">
                      <h4 className="m-0">Loan Summary</h4>{" "}
                      <hr className="flex-grow-1 m-0" />
                      {btnSummryActive && (
                        <button
                          onClick={() =>
                            setState((el) => ({
                              ...el,
                              btnSummryActive: !btnSummryActive,
                            }))
                          }
                          className="btn p-0"
                        >
                          <SummaryCloseIcon />
                        </button>
                      )}
                    </div>

                    <div
                      className="gridCont mb-3 three-col-grid"
                      style={{ gridTemplateRows: "unset" }}
                    >
                      {/*  */}
                      <div className="gridChild gridChildBorderLeftBlue">
                        <div className="gridChildLeft">
                          <p className="gridChld1">
                            {currency(stats?.TotalAmount, {
                              symbol: "",
                            }).format()}
                          </p>
                          <p className="gridChld2">Total Loan Amount</p>
                        </div>

                        <div className="gridChildRight">
                          <SummaryChartIconUp />
                          <p>5%</p>
                        </div>
                      </div>
                      {/*  */}

                      <div className="gridChild gridChildBorderLeftDarkerGreen">
                        <div className="gridChildLeft">
                          <p className="gridChld1">
                            {currency(stats?.AmountPaid, {
                              symbol: "",
                            }).format()}
                          </p>
                          <p className="gridChld2">Total Amount Paid</p>
                        </div>

                        <div className="gridChildRight">
                          <SummaryChartIconUp />
                          <p>5%</p>
                        </div>
                      </div>
                      {/*  */}
                      <div className="gridChild gridChildBorderLeftOrange">
                        <div className="gridChildLeft">
                          <p className="gridChld1">
                            {currency(stats?.TotalAmount, {
                              symbol: "",
                            })
                              .subtract(stats?.AmountPaid)
                              .format()}
                          </p>
                          <p className="gridChld2">Total Withstanding Amount</p>
                        </div>

                        <div className="gridChildRight">
                          <SummaryChartIconUp />
                          <p>5%</p>
                        </div>
                      </div>
                      {/*  */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="my-4">
              <CustomPagination
                setQueryParams={setQueryParams}
                startIndex={returnParams.startIndex}
                endIndex={returnParams.endIndex}
                count={returnParams.count}
                limit={queryParams.limit}
                page={queryParams.page}
                dropDownFunction={dropDownFunction}
              />
            </div>
          </div>
          {/*<!-- /Page Content -->*/}

          {/*<!-- Add Leave Modal -->*/}
          {showApply ? (
            <ApplyLoanModal
              employee={loggedEmployee}
              show={showApply}
              onHide={setShowApply}
              refresh={componentDidMount}
            />
          ) : null}
          {/*<!-- /Add Leave Modal -->*/}

          {/*<!-- Edit Leave Modal -->*/}
          {/* <EditLeaveModal leaveTypes={leaveTypes} editLeave={selectedLeave} /> */}
          {/*<!-- /Edit Leave Modal -->*/}

          {showTerm && (
            <EditTermsModal
              show={showTerm}
              handleClose={() => setState((el) => ({ ...el, showTerm: false }))}
              selectedLoan={selectedLoan}
              refresh={componentDidMount}
            />
          )}

          {openLoanDetails && (
            <LoanDetails
              requestid={requestid}
              show={openLoanDetails}
              staff={staff}
              onHide={() => {
                setState((el) => ({
                  ...el,
                  openLoanDetails: false,
                }));
              }}
            />
          )}
          {openLoanHistory && (
            <LoanHistory
              requestid={requestid}
              show={openLoanHistory}
              onHide={() =>
                setState((el) => ({
                  ...el,
                  openLoanHistory: false,
                }))
              }
            />
          )}
        </div>
        {/*<!-- /Page Wrapper -->*/}
      </div>
      <ModalLoader show={isLoading} />
      {/*<!-- /Main Wrapper -->*/} {/* <!-- Sidebar Overlay --> */}
      <div className="sidebar-overlay" data-reff=""></div>
    </body>
  );
};

const mapStateToProps = (state) => {
  return {
    User: state.api.User,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loan));
